export const buildUpsellSlotAnalytics = (slotId, upsellInformation) => ({
    upsellUUID: upsellInformation.upsell_uuid,
    upsellName: upsellInformation.name ?? '',
    upsellType: upsellInformation.upsell_type,
    upsellLocation: upsellInformation.app_location ?? slotId,
    eventMetadata: upsellInformation.event_metadata,
});
export const getUpsellSlotInstanceId = (upsellInformation) => upsellInformation.upsell_uuid ??
    upsellInformation.name ??
    [
        upsellInformation.app_location,
        upsellInformation.title,
        upsellInformation.description,
        upsellInformation.cta,
    ].join(':');
//# sourceMappingURL=UpsellSlotRenderPlan.js.map